import { bold } from './bold';
import { code, codeBlock } from './code';
import { italic } from './italic';
import { header } from './header';
import { strike } from './strike';
import { underline } from './underline';
import { olist } from './olist';
import { ulist } from './ulist';
import { quote } from './quote';
import { link } from './link';
import { todo } from './todo';
import { image } from './image';
import { redo } from './redo';
import { undo } from './undo';
import { fullscreen } from './fullscreen';
import { preview } from './preview';
export var defaultCommands = {
  undo,
  redo,
  bold,
  italic,
  header,
  strike,
  underline,
  quote,
  olist,
  ulist,
  todo,
  link,
  image,
  code,
  codeBlock,
  fullscreen,
  preview
};
export var getCommands = () => Object.keys(defaultCommands).filter(key => !/^(fullscreen|preview)/.test(key)).map(key => defaultCommands[key]);
export var getModeCommands = () => [preview, fullscreen];